import { createRouter, createWebHistory } from 'vue-router'
import welcome from '../views/Welcome.vue'
import one from '../views/_1.vue'
import two from '../views/_2.vue'
import three from '../views/_3.vue'
import four from '../views/_4.vue'
import seven from '../views/_7.vue'
import processed from '../views/Processed.vue'

const routes = [
  {
    path: '/',
    name: '',
    component: welcome
  },
  {
    path: '/nour',
    name: '| Nour',
    component: one
  },
  {
    path: '/fertile',
    name: '| Fertile',
    component: seven
  },
  {
    path: '/peel',
    name: '| PEEL',
    component: two
  },
  {
    path: '/collaborations',
    name: '| Collaborations',
    component: three
  },
  {
    path: '/installations',
    name: '| Installations',
    component: four
  },
  {
    path: '/store/processed',
    name: '| Thank you!',
    component: processed
  },
  {
    path: '/store/terms',
    name: '| Shipping and terms',
    component: () => import(/* webpackChunkName: "terms" */ '../views/Terms.vue')
  },
  {
    path: '/about',
    name: '| About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/store',
    name: '| Store',
    component: () => import(/* webpackChunkName: "store" */ '../views/StoreOverview.vue'),
  },
  {
      path: '/store/:slug',
    name: '| Store Detail',
    component: () => import(/* webpackChunkName: "store" */ '../views/Store.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = `Marinka Grondel ${to.name}`;
  next();
});

export default router
